const { getCookie } = require("../../global/cookie");

const clearImageFlux = (cb = () => {}) => {
  let objBody = { aiwp_logged_in: getCookie("aiwp_logged_in") };
  const url = require("../../global/url");

  const requestOptions = {
    method: 'POST',
    mode: 'cors',
    body: JSON.stringify(objBody)
  };

  fetch(`${url.api}/e/clear-image-flux`, requestOptions)
    .then(response => {
      return response.json();
    })
    .then(data => {
      cb(data);
    });
}

const removeImageFlux = (replicate = "", cb = () => {}) => {
  if(!replicate) return;
  const url = require("../../global/url");
  let objBody = { aiwp_logged_in: getCookie("aiwp_logged_in"), replicate };

  const requestOptions = {
    method: 'POST',
    mode: 'cors',
    body: JSON.stringify(objBody)
  };

  fetch(`${url.api}/e/delete-image-flux`, requestOptions)
    .then(response => {
      return response.json();
    })
    .then(data => {
      cb(data);
    });
};

module.exports = {
  removeImageFlux,
  clearImageFlux
};